(function () {
  'use strict';

  var VERSION = '2026-07-10.1';
  var CONFIG = {
    DEBUG: false,
    PROMO_ACTIVE: false,
    GIFT_VARIANT_ID: 43329060765744,
    THRESHOLD_CENTS: 10000,
    OPT_OUT_KEY: 'ny_half_half_gift_opt_out'
  };

  var previousApi = window.NYHalfHalfGift || {};
  var nativeFetch = previousApi._nativeFetch || window.fetch.bind(window);
  var giftVariantIdText = String(CONFIG.GIFT_VARIANT_ID);
  var state = {
    syncing: false,
    queuedReason: null,
    timer: null,
    lastCart: null,
    addBlockedUntil: 0,
    subscribedToThemeCartEvents: false
  };

  function log() {
    if (!CONFIG.DEBUG || !window.console) return;
    window.console.log.apply(window.console, ['[NY Half Half Gift]'].concat(Array.prototype.slice.call(arguments)));
  }

  function markDebug(key, value) {
    try {
      if (document.documentElement) {
        document.documentElement.setAttribute('data-ny-half-half-gift-' + key, String(value).slice(0, 160));
      }
    } catch (error) {
      // Diagnostics should never affect the cart.
    }
  }

  function routesRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function cartUrl(path) {
    var root = routesRoot().replace(/\/$/, '');
    return root + path;
  }

  function requestJson(url, options) {
    var requestOptions = options || {};
    var headers = new Headers(requestOptions.headers || {});
    headers.set('Accept', 'application/json');
    headers.set('X-NY-Half-Half-Gift', '1');
    requestOptions.headers = headers;

    return nativeFetch(url, requestOptions).then(function (response) {
      if (!response.ok) {
        var error = new Error('Shopify cart request failed with status ' + response.status);
        error.status = response.status;
        throw error;
      }
      return response.json();
    });
  }

  function getCart() {
    return requestJson(cartUrl('/cart.js'), { cache: 'no-store' });
  }

  function isGiftItem(item) {
    if (!item) return false;
    if (String(item.variant_id) === giftVariantIdText) return true;
    if (item.properties && item.properties._ny_half_half_gift) return true;
    return false;
  }

  function giftItems(cart) {
    var gifts = [];
    if (!cart || !cart.items) return gifts;

    cart.items.forEach(function (item, index) {
      if (isGiftItem(item)) {
        gifts.push({ item: item, line: index + 1 });
      }
    });

    return gifts;
  }

  function nonGiftSubtotal(cart) {
    if (!cart || !cart.items) return 0;

    return cart.items.reduce(function (total, item) {
      if (isGiftItem(item)) return total;
      if (typeof item.final_line_price === 'number') return total + item.final_line_price;
      return total + ((item.price || 0) * (item.quantity || 0));
    }, 0);
  }

  function changeLine(line, quantity) {
    return requestJson(cartUrl('/cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    });
  }

  function addGift() {
    markDebug('last-action', 'add-gift');
    return requestJson(cartUrl('/cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: CONFIG.GIFT_VARIANT_ID,
          quantity: 1,
          properties: { _ny_half_half_gift: 'true' }
        }]
      })
    });
  }

  function removeGiftItems(cart) {
    markDebug('last-action', 'remove-gift');
    var gifts = giftItems(cart).sort(function (a, b) { return b.line - a.line; });
    var chain = Promise.resolve(false);

    gifts.forEach(function (gift) {
      chain = chain.then(function () {
        return changeLine(gift.line, 0).then(function () { return true; });
      });
    });

    return chain;
  }

  function normaliseGiftItems(cart) {
    var gifts = giftItems(cart).sort(function (a, b) { return a.line - b.line; });
    if (!gifts.length) return Promise.resolve(false);

    var keeper = gifts[0];
    var extras = gifts.slice(1).sort(function (a, b) { return b.line - a.line; });
    var chain = Promise.resolve(false);

    extras.forEach(function (gift) {
      chain = chain.then(function () {
        return changeLine(gift.line, 0).then(function () { return true; });
      });
    });

    chain = chain.then(function (changed) {
      if (keeper.item.quantity !== 1) {
        return changeLine(keeper.line, 1).then(function () { return true; });
      }
      return changed;
    });

    return chain;
  }

  function parseSectionInner(html, selector) {
    if (!html) return null;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var element = doc.querySelector(selector);
    return element ? element.innerHTML : null;
  }

  function reconnectDrawer(drawer) {
    if (!drawer) return;

    var overlay = drawer.querySelector('#CartDrawer-Overlay');
    if (overlay && typeof drawer.close === 'function') {
      overlay.addEventListener('click', drawer.close.bind(drawer, false));
    }

    if (typeof drawer.setHeaderCartIconAccessibility === 'function') {
      drawer.setHeaderCartIconAccessibility();
    }

    var slider = document.querySelector('cart-popular-products-slider');
    if (slider && typeof slider.init === 'function') {
      slider.init();
    }
  }

  function setCartEmptyClasses(cart) {
    var empty = !cart || !cart.item_count;
    var drawerInner = document.querySelector('cart-drawer .drawer__inner');
    var drawerItems = document.querySelector('cart-drawer-items');

    if (drawerInner) drawerInner.classList.toggle('is-empty', empty);
    if (drawerItems) drawerItems.classList.toggle('is-empty', empty);
  }

  function refreshWithThemeCartItems(sections) {
    var cartItems = document.querySelector('cart-drawer-items') || document.querySelector('cart-items');
    var didRefresh = false;

    if (!cartItems || typeof cartItems.getSectionsToRender !== 'function' || typeof cartItems.getSectionInnerHTML !== 'function') {
      return false;
    }

    try {
      cartItems.getSectionsToRender().forEach(function (section) {
        var html = sections[section.section];
        var container = document.getElementById(section.id);
        var elementToReplace = null;

        if (!html || !container) return;

        if (section.selector) {
          elementToReplace = container.querySelector(section.selector);
        }
        if (!elementToReplace) elementToReplace = container;

        elementToReplace.innerHTML = cartItems.getSectionInnerHTML(html, section.selector);
        didRefresh = true;
      });
    } catch (error) {
      markDebug('last-refresh-error', error && error.message ? error.message : error);
      return false;
    }

    if (didRefresh) markDebug('last-refresh', 'theme-cart-items');
    return didRefresh;
  }

  function refreshCartSurfaces(cart, force) {
    var drawer = document.querySelector('cart-drawer');
    var bubble = document.getElementById('cart-icon-bubble');

    if (!force && !drawer && !bubble) return Promise.resolve(cart);

    var sectionUrl = routesRoot() + '?sections=cart-drawer,cart-icon-bubble&sections_url=' + encodeURIComponent(window.location.pathname);

    return requestJson(sectionUrl).then(function (sections) {
      drawer = document.querySelector('cart-drawer');
      bubble = document.getElementById('cart-icon-bubble');

      if (refreshWithThemeCartItems(sections)) {
        reconnectDrawer(drawer);
        setCartEmptyClasses(cart);
        return cart;
      }

      if (drawer && sections['cart-drawer']) {
        markDebug('last-refresh', 'drawer-root');
        var drawerTarget = document.querySelector('#CartDrawer') || drawer;
        var drawerHtml = null;

        if (typeof drawer.getSectionInnerHTML === 'function') {
          try {
            drawerHtml = drawer.getSectionInnerHTML(sections['cart-drawer'], '#CartDrawer');
          } catch (error) {
            drawerHtml = null;
          }
        }

        if (drawerHtml === null) {
          drawerHtml = parseSectionInner(sections['cart-drawer'], '#CartDrawer');
        }

        if (drawerTarget && drawerHtml !== null) {
          drawerTarget.innerHTML = drawerHtml;
          reconnectDrawer(drawer);
        }
      }

      if (bubble && sections['cart-icon-bubble']) {
        markDebug('last-refresh-bubble', 'fallback');
        var bubbleHtml = parseSectionInner(sections['cart-icon-bubble'], '.shopify-section');
        if (bubbleHtml === null) bubbleHtml = parseSectionInner(sections['cart-icon-bubble'], '#cart-icon-bubble');
        if (bubbleHtml !== null) bubble.innerHTML = bubbleHtml;
      }

      setCartEmptyClasses(cart);
      return cart;
    }).catch(function (error) {
      log('surface refresh skipped', error && error.message ? error.message : error);
      setCartEmptyClasses(cart);
      return cart;
    });
  }

  function storageGet(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function storageSet(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (error) {
      // Ignore storage failures; the cart still reconciles normally.
    }
  }

  function storageRemove(key) {
    try {
      window.sessionStorage.removeItem(key);
    } catch (error) {
      // Ignore storage failures.
    }
  }

  function isGiftOptedOut() {
    return storageGet(CONFIG.OPT_OUT_KEY) === '1';
  }

  function markGiftOptOut(reason) {
    storageSet(CONFIG.OPT_OUT_KEY, '1');
    log('gift opt-out set', reason || 'unknown');
  }

  function clearGiftOptOut() {
    storageRemove(CONFIG.OPT_OUT_KEY);
  }

  function isGiftVariantRef(value) {
    if (value === null || typeof value === 'undefined') return false;
    var text = String(value);
    return text === giftVariantIdText || text.indexOf(giftVariantIdText + ':') === 0;
  }

  function lineRefersToGift(line) {
    var index = Number(line) - 1;
    if (!state.lastCart || !state.lastCart.items || index < 0) return false;
    return isGiftItem(state.lastCart.items[index]);
  }

  function keyRefersToGiftLine(key) {
    if (!state.lastCart || !state.lastCart.items) return false;
    return state.lastCart.items.some(function (item) {
      return isGiftItem(item) && String(item.key) === String(key);
    });
  }

  function isZeroQuantity(value) {
    return Number(value) === 0;
  }

  function bodyToObject(init) {
    var body = init && init.body;
    var data = {};

    if (!body) return null;

    if (typeof body === 'string') {
      try {
        return JSON.parse(body);
      } catch (error) {
        return null;
      }
    }

    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      body.forEach(function (value, key) {
        data[key] = value;
      });
      return data;
    }

    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      body.forEach(function (value, key) {
        data[key] = value;
      });
      return data;
    }

    return null;
  }

  function detectGiftOptOut(path, init) {
    if (!/\/cart\/(change|update)(\.js)?$/.test(path)) return;

    var data = bodyToObject(init);
    if (!data) return;

    if (isZeroQuantity(data.quantity)) {
      if (lineRefersToGift(data.line) || isGiftVariantRef(data.id) || keyRefersToGiftLine(data.id)) {
        markGiftOptOut('cart-change');
        return;
      }
    }

    if (data.updates && typeof data.updates === 'object') {
      Object.keys(data.updates).some(function (key) {
        if (!isZeroQuantity(data.updates[key])) return false;
        if (isGiftVariantRef(key) || keyRefersToGiftLine(key)) {
          markGiftOptOut('cart-update');
          return true;
        }
        return false;
      });
    }
  }

  function reconcileGift(cart) {
    var gifts = giftItems(cart);

    if (!CONFIG.PROMO_ACTIVE) {
      markDebug('status', 'retired');
      clearGiftOptOut();
      if (gifts.length) return removeGiftItems(cart);
      return Promise.resolve(false);
    }

    var subtotal = nonGiftSubtotal(cart);
    markDebug('subtotal', subtotal);
    markDebug('gift-lines', gifts.length);
    markDebug('opted-out', isGiftOptedOut() ? '1' : '0');

    if (subtotal < CONFIG.THRESHOLD_CENTS) {
      clearGiftOptOut();
      if (gifts.length) return removeGiftItems(cart);
      return Promise.resolve(false);
    }

    if (isGiftOptedOut()) {
      if (gifts.length) return removeGiftItems(cart);
      return Promise.resolve(false);
    }

    if (!gifts.length) {
      if (state.addBlockedUntil && Date.now() < state.addBlockedUntil) return Promise.resolve(false);

      return addGift().then(function () {
        markDebug('last-action', 'add-gift-success');
        return true;
      }).catch(function (error) {
        markDebug('last-error', 'add:' + (error && error.status ? error.status : (error && error.message ? error.message : error)));
        if (error && (error.status === 400 || error.status === 422)) {
          state.addBlockedUntil = Date.now() + (15 * 60 * 1000);
        }
        log('gift add skipped', error && error.message ? error.message : error);
        return false;
      });
    }

    return normaliseGiftItems(cart);
  }

  function shouldRefresh(reason, changed) {
    if (changed) return true;
    if (!reason) return false;
    return /fetch|pubsub|cart|manual|late/.test(reason);
  }

  function sync(reason) {
    if (state.syncing) {
      state.queuedReason = reason || 'queued';
      return Promise.resolve(false);
    }

    state.syncing = true;
    reason = reason || 'manual';
    log('sync start', reason);
    markDebug('last-sync', reason);
    markDebug('last-error', '');

    var changed = false;

    return getCart()
      .then(function (cart) {
        state.lastCart = cart;
        return reconcileGift(cart).then(function (didChange) {
          changed = didChange;
          if (!didChange) return cart;
          return getCart().then(function (freshCart) {
            state.lastCart = freshCart;
            return freshCart;
          });
        });
      })
      .then(function (cart) {
        return refreshCartSurfaces(cart, shouldRefresh(reason, changed));
      })
      .catch(function (error) {
        markDebug('last-error', error && error.message ? error.message : error);
        log('sync skipped', error && error.message ? error.message : error);
        return false;
      })
      .then(function (result) {
        state.syncing = false;
        if (state.queuedReason) {
          var queuedReason = state.queuedReason;
          state.queuedReason = null;
          scheduleSync(queuedReason, 250);
        }
        return result;
      });
  }

  function scheduleSync(reason, delay) {
    if (state.timer) window.clearTimeout(state.timer);
    state.timer = window.setTimeout(function () {
      state.timer = null;
      sync(reason);
    }, delay || 0);
  }

  function scheduleAfterCartMutation(reason) {
    markDebug('last-schedule', reason);
    scheduleSync(reason, 700);
    window.setTimeout(function () {
      sync(reason + ':late');
    }, 1800);
  }

  function pathFromInput(input) {
    var raw = '';
    if (typeof input === 'string') raw = input;
    else if (input && input.url) raw = input.url;

    try {
      return new URL(raw, window.location.origin).pathname;
    } catch (error) {
      return '';
    }
  }

  function headersContain(headers, name) {
    var lowerName = name.toLowerCase();
    var found = false;

    if (!headers) return false;

    try {
      if (typeof Headers !== 'undefined' && headers instanceof Headers) {
        return headers.has(name);
      }
    } catch (error) {
      // Continue with object/array checks.
    }

    if (Array.isArray(headers)) {
      headers.some(function (pair) {
        if (pair && String(pair[0]).toLowerCase() === lowerName) {
          found = true;
          return true;
        }
        return false;
      });
      return found;
    }

    Object.keys(headers).some(function (key) {
      if (key.toLowerCase() === lowerName) {
        found = true;
        return true;
      }
      return false;
    });

    return found;
  }

  function isInternalRequest(input, init) {
    if (headersContain(init && init.headers, 'X-NY-Half-Half-Gift')) return true;
    if (input && headersContain(input.headers, 'X-NY-Half-Half-Gift')) return true;
    return false;
  }

  function isCartMutationPath(path) {
    return /\/cart\/(add|change|update|clear)(\.js)?$/.test(path);
  }

  function patchFetch() {
    if (window.NYHalfHalfGiftFetchPatched) return;
    window.NYHalfHalfGiftFetchPatched = true;

    window.fetch = function (input, init) {
      var path = pathFromInput(input);
      var internal = isInternalRequest(input, init);
      var cartMutation = !internal && isCartMutationPath(path);

      if (cartMutation) {
        markDebug('last-fetch', path);
        detectGiftOptOut(path, init);
      }

      var responsePromise = nativeFetch.apply(window, arguments);

      if (cartMutation) {
        responsePromise.then(function (response) {
          if (response && response.ok) {
            if (/\/cart\/clear(\.js)?$/.test(path)) clearGiftOptOut();
            scheduleAfterCartMutation('fetch:' + path);
          }
        }).catch(function () {
          // Shopify/theme code handles user-facing cart request failures.
        });
      }

      return responsePromise;
    };
  }

  function subscribeToThemeCartEvents() {
    if (state.subscribedToThemeCartEvents) return;
    if (typeof window.subscribe !== 'function' || !window.PUB_SUB_EVENTS || !window.PUB_SUB_EVENTS.cartUpdate) {
      return;
    }

    state.subscribedToThemeCartEvents = true;
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'ny-half-half-gift') return;
      if (event && event.cartData) state.lastCart = event.cartData;
      scheduleAfterCartMutation('pubsub:cartUpdate');
    });
  }

  function targetClosest(target, selector) {
    return !!(target && typeof target.closest === 'function' && target.closest(selector));
  }

  function bindCartUiFallbacks() {
    if (window.NYHalfHalfGiftUiFallbacksBound) return;
    window.NYHalfHalfGiftUiFallbacksBound = true;

    document.addEventListener('click', function (event) {
      var selector = 'form[action*="/cart/add"] button, product-form button, cart-remove-button, quantity-input button, cart-drawer quantity-input button, cart-items quantity-input button';
      if (targetClosest(event.target, selector)) {
        markDebug('last-ui', 'click');
        scheduleAfterCartMutation('ui:click');
      }
    }, true);

    document.addEventListener('change', function (event) {
      var selector = 'cart-drawer input[name="updates[]"], cart-items input[name="updates[]"], quantity-input input, input[name="quantity"]';
      if (targetClosest(event.target, selector)) {
        markDebug('last-ui', 'change');
        scheduleAfterCartMutation('ui:change');
      }
    }, true);
  }

  function markRuntimeVersion() {
    if (document.documentElement) {
      document.documentElement.setAttribute('data-ny-half-half-gift-version', VERSION);
    }
  }

  function init() {
    markRuntimeVersion();
    patchFetch();
    bindCartUiFallbacks();
    subscribeToThemeCartEvents();
    window.setTimeout(subscribeToThemeCartEvents, 1000);
    scheduleSync('init', 600);
  }

  window.NYHalfHalfGift = {
    version: VERSION,
    sync: sync,
    getCart: getCart,
    clearOptOut: clearGiftOptOut,
    isOptedOut: isGiftOptedOut,
    _nativeFetch: nativeFetch
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
